import type { ApiAppParams } from 'typings/apiApp';

export enum AppEvents {
  TOGGLE_TOOLTIP = 'app/toggleTooltip',
  TOGGLE_CART = 'app/toggleCart',
  TOGGLE_CHAT = 'app/toggleChat',
  RESET_CONFIG = 'app/resetConfig',
  UPDATE_PARAMS = 'app/updateParams',
  UPDATE_SESSION = 'app/updateSession',
  SEND_NEW_MESSAGE = 'app/sendNewMessage',
  UPDATE_PRODUCT_LIST = 'app/updateProductList',
  GET_SUGGESTION = 'app/getSuggestion',
  SHOW_CROSS_SALE = 'app/showCrossSale',
  RESET_CHAT = 'app/resetChat',
  TRIGGER_SEMI_OPEN = 'app/triggerSemiOpen',
  REOPEN_CHAT = 'app/reopenChat',
}

export const toggleTooltip = (isOpenTooltip: boolean, showCloseBtn?: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_TOOLTIP, {
    detail: {
      isOpenTooltip,
      showCloseBtn,
    },
  });

  window.dispatchEvent(event);
};

export const toggleAppChat = (isOpenChat?: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_CHAT, {
    detail: isOpenChat,
  });

  window.dispatchEvent(event);
};

export const updateAppParams = (params?: Partial<ApiAppParams>) => {
  const event = new CustomEvent(AppEvents.UPDATE_PARAMS, {
    detail: params,
  });

  window.dispatchEvent(event);
};

export const toggleCart = (isOpenCart?: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_CART, {
    detail: isOpenCart,
  });

  window.dispatchEvent(event);
};

export const updateProductList = () => {
  const event = new CustomEvent(AppEvents.UPDATE_PRODUCT_LIST);

  window.dispatchEvent(event);
};

export const sendNewMessage = (messageText: string, selectedOptions?: string[]) => {
  const event = new CustomEvent(AppEvents.SEND_NEW_MESSAGE, {
    detail: {
      messageText,
      selectedOptions,
    },
  });
  window.dispatchEvent(event);
};

export const updateSession = () => {
  const event = new CustomEvent(AppEvents.UPDATE_SESSION);
  window.dispatchEvent(event);
};

export const resetConfig = () => {
  const event = new CustomEvent(AppEvents.RESET_CONFIG);
  window.dispatchEvent(event);
};

export const resetChat = () => {
  const event = new CustomEvent(AppEvents.RESET_CHAT);
  window.dispatchEvent(event);
};

export const getSuggestion = (productsList: string[]) => {
  const event = new CustomEvent(AppEvents.GET_SUGGESTION, {
    detail: {
      productsList,
    },
  });
  window.dispatchEvent(event);
};

export const showCrossSale = () => {
  const event = new CustomEvent(AppEvents.SHOW_CROSS_SALE);
  window.dispatchEvent(event);
};

export const triggerSemiOpen = () => {
  window.dispatchEvent(new CustomEvent(AppEvents.TRIGGER_SEMI_OPEN));
};

export const reopenChat = (detail: { token: string; chatId: number }) => {
  window.dispatchEvent(new CustomEvent(AppEvents.REOPEN_CHAT, { detail }));
};
